module.exports = __webpack_public_path__ + "assets/instructionEmailChange-4af205fe88c8439f757b4365d117e850.png";